import { z, ZodType } from 'zod';
import { entityWithNameSchema } from './entity-with-name';
import { Shift } from './shift';

export type ShiftTotal = Shift & {
	totalDeposits: number;
	totalWithdrawals: number;
	totalIncome: number;
};

export const shiftTotalSchema: ZodType<ShiftTotal> = z.object({
	id: z.string(),
	openingBalance: z.number(),
	closingBalance: z.number(),
	currency: z.string(),
	isActive: z.boolean(),
	owner: entityWithNameSchema,
	totalDeposits: z.number(),
	totalWithdrawals: z.number(),
	totalIncome: z.number(),
});
